import ReactGA from 'react-ga';
import {currentEnvironment} from 'src/shared/utilities/environment';

export const trackPageview = () => {
  if (currentEnvironment() === 'production') {
    ReactGA.initialize('UA-157843520-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
};
